// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".create-comment-container{background:var(--color-secondary)}.create-comment-container .create-comment{align-items:center;background-color:var(--color-neutral-3);border:1px solid var(--color-neutral-4);border-radius:12px;flex-wrap:wrap;width:calc(100% - 75px)}.create-comment-container .create-comment:focus-within{border:1px solid var(--color-primary)}.create-comment-container .post-btn{height:32px;width:60px}.create-comment-container .emoji-picker{z-index:1000}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"a": "#5a80fb",
	"b": "#6b88fc",
	"c": "#7b91fc",
	"d": "#8899fd",
	"e": "#95a2fd",
	"f": "#a1abfe",
	"g": "#adb4fe",
	"h": "#b8bdfe",
	"i": "#c3c6ff",
	"j": "#cdcfff",
	"k": "#d8d9ff",
	"l": "#e2e2ff",
	"m": "#ececff",
	"n": "#f5f5ff",
	"o": "#fff"
};
module.exports = ___CSS_LOADER_EXPORT___;
